//------------------------------------------------------------------------
// Wrap words to prevent orphans
//
// Based on https://github.com/simeydotme/jquery-unorphanize
//------------------------------------------------------------------------
// Example (no value passed):
// <p data-orphans>Lorem ipsum dolor sit amet</p>
//
// Output:
// <p>Lorem ipsum dolor sit&nbsp;amet</p>
//------------------------------------------------------------------------
// Example (pass word count value):
// <p data-orphans="3">Lorem ipsum dolor sit amet</p>

// Output:
// <p>Lorem ipsum dolor&nbsp;sit&nbsp;amet</p>
//------------------------------------------------------------------------
// Example (use JSON data to pass multiple parameters):
// <p data-orphans='{"words":"2", "wrap":"true"}'>Lorem ipsum dolor sit amet</p>
//
// Output:
// <p>Lorem ipsum dolor <span class="u-nowrap">sit amet</span></p>
//------------------------------------------------------------------------
'use strict';
import $ from 'jquery';
import Backbone from 'backbone';
import 'jquery-unorphanize';

var Orphans = Backbone.View.extend({
  initialize: function() {
    this.data = this.$el.attr('data-orphans');

    // Check for curly brace to see if we need to test for JSON
    this.isJSON = ( this.data.indexOf('{') !== -1 ? true : false );

    if ( this.isJSON ) {
      // Check to make sure data-orphans value is formatted as JSON
      try {
        $.parseJSON( this.data );
      } catch(e) {
        this.isJSON = false;
      }
    }

    // If JSON was passed, parse it
    if ( this.isJSON ) {
      this.data = $.parseJSON( this.data );
    }
    // If not JSON, assume single integer was passed for word count
    else {
      // If no value passed, use default word count
      if ( !this.data.length ) {
        this.words = 2;
      }
      else {
        this.words = parseInt( this.data, 10 );
      }
    }

    // Wrap words in span
    if ( this.isJSON && this.data.wrap.toLowerCase() === 'true' ) {
      this.$el.unorphanize({
        words: parseInt( this.data.words, 10 ),
        wrapEl: "span",
        className: "u-nowrap"
      });
    }
    // Use &nbsp;
    else {
      this.$el.unorphanize({
        words: this.words
      });
    }

    // Remove attribute
    this.$el.removeAttr('data-orphans');
  }
});

$("[data-orphans]").each( function(i) {
  var orphans = new Orphans({ el: this });
});

export default Orphans;